export default async function fileToDataUri(file: File): Promise<string> {
  return `data:image/png;base64,${Buffer.from(
    await file.arrayBuffer()
  ).toString("base64")}`;
}
